import { createContext, useContext, useRef, useState } from "react";
import { api, apiFile } from "../api";

export const DebugTransferContext = createContext({
  canDownload: false, canUpload: false,
  onImported: async (_caseId?: number | null, _message?: string) => {},
});

export function DebugTransferControls({ scope, targetId, disabled = false, onImported }: {
  scope: "invoices" | "customs" | "case"; targetId: string | number;
  disabled?: boolean; onImported?: () => void | Promise<void>;
}) {
  const access = useContext(DebugTransferContext);
  const fileInput = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const noun = scope === "invoices" ? "Faturaları" : scope === "customs" ? "Dosyaları" : "Belgeleri";
  const url = `/api/debug-transfer/${scope}/${targetId}`;
  if (!access.canDownload) return null;

  async function download() {
    setBusy(true); setMessage("");
    try {
      const file = await apiFile(url);
      const objectUrl = URL.createObjectURL(file.blob);
      const anchor = document.createElement("a");
      anchor.href = objectUrl; anchor.download = file.filename || `vrp-${scope}.zip`; anchor.click();
      window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    } catch (reason) { setMessage(reason instanceof Error ? reason.message : String(reason)); }
    finally { setBusy(false); }
  }
  async function upload(file?: File) {
    if (!file) return;
    setBusy(true); setMessage("");
    try {
      const form = new FormData(); form.append("file", file);
      const result = await api<{ detail: string; warnings: string[]; case_id?: number | null }>(url, { method: "POST", body: form });
      await onImported?.();
      await access.onImported(result.case_id, [result.detail, ...result.warnings].join(" "));
    } catch (reason) { setMessage(reason instanceof Error ? reason.message : String(reason)); }
    finally { setBusy(false); }
  }
  return <span className="debug-transfer-controls">
    <button type="button" className="secondary-button compact" disabled={disabled || busy || !targetId} onClick={() => void download()}>{busy ? "Aktarılıyor…" : `Tüm ${noun} İndir`}</button>
    <button type="button" className="secondary-button compact" disabled={!access.canUpload || disabled || busy || !targetId}
      title={access.canUpload ? "Aynı VKN’ye ait boş hedefe VRP ZIP paketi yükleyin." : "Yükleme yalnız local geliştirme ortamında açıktır."}
      onClick={() => fileInput.current?.click()}>{`Tüm ${noun} Yükle`}</button>
    <input ref={fileInput} hidden type="file" accept=".zip,application/zip" onChange={event => {
      const file = event.target.files?.[0]; event.target.value = ""; void upload(file);
    }} />
    {message && <span role="status">{message}</span>}
  </span>;
}
